<template>
  <div v-if="value.length <= truncateAt">
    <div v-if="displayHtml" v-html="value"></div>
    <div v-else>
      {{ value }}
    </div>
  </div>
  <div v-else>
    <div v-if="displayHtml" v-html="truncatedValue" v-tooltip.bottom-start="tooltipOptions"></div>
    <div v-else v-tooltip.bottom-start="tooltipOptions">
      {{ truncatedValue }}
    </div>
  </div>
</template>

<script>
import { VTooltip } from 'v-tooltip';

export default {
  name: 'BaseTruncatedField',

  directives: {
    tooltip: VTooltip,
  },

  props: {
    value: {
      type: String,
      default: '',
    },

    truncateAt: {
      type: Number,
      default: 50,
    },

    displayHtml: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    truncatedValue() {
      return `${this.value.slice(0, this.truncateAt)}...`;
    },

    tooltipOptions() {
      return {
        content: this.value,
        html: true,
      };
    },
  },
};
</script>

<style scoped>
@import '../../../assets/css/tooltip.css';
</style>
